import { BrandAndMarketListItem, GuidIdAndLabel, VccCredentialsV2OrderValue } from '../../../integrated-client/models';
import { DEFAULT_PAGE_SIZE, DEFAULT_TOTAL_ITEMS } from '../../../utils/Constants';

export interface IFiltersData {
  brandAndMarket?: BrandAndMarketListItem | null;
  cardProvider?: GuidIdAndLabel | null;
  description?: string | null;
  showDisabled?: boolean;
  orderValue?: VccCredentialsV2OrderValue;
  orderByDescending?: boolean;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem | null;
  cardProvider?: GuidIdAndLabel | null;
  description?: string | null;
  showDisabled?: boolean;
  orderValue?: VccCredentialsV2OrderValue;
  orderByDescending?: boolean;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;

  constructor() {
    this.brandAndMarket = null;
    this.cardProvider = null;
    this.description = null;
    this.showDisabled = false;
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }
}
